import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic/dinamicApi";
import { fetchMenu } from "features/menu";
import { selectRol } from "features/Administrador/rol";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";

interface PermisoState {
    status: string;
    error: string;
    permisoList: any[],
    permisoSeleccionadoList: any[],
    permisoAsignadoList: any[],
    permiso: {
        idPermiso: number | null;
        idOpcion: number | null;
        nombre: string | null;
    }
}

const initialState: PermisoState = {
    status: 'idle',
    error: '',
    permisoList: [],
    permisoSeleccionadoList: [],
    permisoAsignadoList: [],
    permiso: {
        idPermiso: null,
        idOpcion: null,
        nombre: null,
    }
}

export const fetchPermisoActivo = createAsyncThunk('fetchPermisoActivo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const rol = selectRol(state);
    const rolAttributes = { ...rol }
    const idRol = rolAttributes.idRol;
    const idsp = 37;
    const { result, message, data } = await getData({ idsp, idRol }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchPermisoRol = createAsyncThunk('fetchPermisoRol', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const rol = selectRol(state);
    const rolAttributes = { ...rol }
    const idRol = rolAttributes.idRol;
    const idsp = 26;
    const { result, message, data } = await getData({ idsp, idRol }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const createPermiso = createAsyncThunk('createPermiso', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const permiso = selectPermiso(state);
    const permisoAttributes = { ...permiso };
    const idOpcion = permisoAttributes.idOpcion;
    const rol = selectRol(state);
    const rolAttributes = { ...rol }
    const idRol = rolAttributes.idRol;
    const idsp = 27;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, idOpcion, idRol }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchPermisoRol({}));
    dispatch(fetchPermisoActivo({}));
    dispatch(fetchMenu({}));
    return rejectWithValue(message);
});

export const deletePermiso = createAsyncThunk('deletePermiso', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const permiso = selectPermiso(state);
    const permisoAttributes = { ...permiso };
    const idOpcion = permisoAttributes.idOpcion;
    const rol = selectRol(state);
    const rolAttributes = { ...rol }
    const idRol = rolAttributes.idRol;
    const idsp = 28;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, idOpcion, idRol }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchPermisoRol({}));
    dispatch(fetchPermisoActivo({}));
    dispatch(fetchMenu({}));
    return rejectWithValue(message);
});


export const permisoSlice = createSlice({
    name: 'permiso',
    initialState,
    reducers: {
        setPermisoList: (state, action) => {
            state.permisoList = action.payload;
        },
        setPermisoSeleccionadoList: (state, action) => {
            state.permisoSeleccionadoList = action.payload;
        },
        setPermisoAsignadoList: (state, action) => {
            state.permisoAsignadoList = action.payload;
        },
        setPermiso: (state, action) => {
            state.permiso = !action.payload ? initialState.permiso : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchPermisoActivo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPermisoActivo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.permisoList = data ? data : [];

            })
            .addCase(fetchPermisoActivo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchPermisoRol.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPermisoRol.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.permisoAsignadoList = data ? data : [];
            })
            .addCase(fetchPermisoRol.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(createPermiso.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createPermiso.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(createPermiso.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(deletePermiso.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletePermiso.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(deletePermiso.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    },
});

export const selectPermisoList = (state: RootState) => state.permiso.permisoList;
export const selectPermisoSeleccionadoList = (state: RootState) => state.permiso.permisoSeleccionadoList;
export const selectPermisoAsignadoList = (state: RootState) => state.permiso.permisoAsignadoList;
export const selectPermiso = (state: RootState) => state.permiso.permiso;

export const { setPermisoList, setPermisoSeleccionadoList, setPermisoAsignadoList, setPermiso } = permisoSlice.actions;

export default permisoSlice.reducer;